<template>
    <div class="container">
        <FullPageLoading
            :show="showLoading"
            :label="labelLoading"
        />

        <div class="row">
            <div class="col-6 col-md-6 col-lg-6 offset-md-3 offset-lg-3 newsfeed">
                <div class="d-flex flex-column">
                    <h4>Notification</h4>
                    <hr>
                    <div v-if="notification.length > 0">
                        <div class="card w-100 p-3" v-for="(item, i) in notification" :key="i">
                            {{ item.body }} <br> <small class="text-secondary">{{ item.created_at | date }}</small>
                        </div>
                    </div>
                    <div v-else>
                        <h6>No Notifications</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import FullPageLoading from './FullPageLoading.vue';

export default {
    components: {
        FullPageLoading,
    },
    data() {
        return {
            showLoading: false,
            labelLoading: 'Please Wait...',
            notification: [],
        }
    },
    computed: {
        isLogin: function () {
            return this.$store.state.isLogin;
        },
        dataUser: function () {
            if (this.isLogin) {
                return this.$store.state.dataUser;
            } else {
                return [];
            }
        },
    },
    filters: {
        date: function(val) {
            return moment(val, 'YYYY-MM-DD HH:mm:ss').format('ddd, DD MMMM hh:mm');
        },
    },
    created() {
        this.showLoading = true;
        this.checkNotification();
    },
    methods: {
        async checkNotification() {
            this.showLoading = true;
            let payload = {
                scope: 'loadNotification',
                data: {
                    access_token: this.dataUser.access_token,
                    user_id: this.dataUser.id,
                },
            };

            try {
                let load = await this.$store.dispatch('message', payload);
                if (load.data.status) {
                    this.showLoading = false;
                    this.notification = load.data.message;
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Load Notification Failed! Please refresh the page!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Load Notification Failed! Please refresh the page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        }
    }
}
</script>